import { useState, useEffect } from "react";

import React from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import quoation from "../../../images/Quation.png";
import pencil from "../../../images/pencil.jpg";
import edit from "../../../images/edit.png";
import rectangle from "../../../images/Rectangle.png";
import add from "../../../images/Add_button.jpg";
import updatebutton from "../../../images/update_button.jpg";
import { useNavigate } from "react-router-dom";
import "../../SalesMasterPages/DomesticRelocationRoad/DomesticRelocationRoad.css"


const DomesticRelocationRoad = () => {
  const location = useLocation();
  const baseAPI = process.env.REACT_APP_API_URL;
  const [decryptionError, setDecryptionError] = useState(false);
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const relocation_id = location.state?.relocation_id;
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);



  const Relocation_ID = decryptRelocationID(relocation_id);
  const [inputs, setInputs] = useState([{ cmp_additional_sow_id: '', Relocation_ID, specific_requirement: '', price: '' }]);

  const handleAddFields = () => {
    setInputs([...inputs, { Relocation_ID, specific_requirement: '', price: '' }]);
  };

  const handleRemoveFields = (index) => {
    setInputs(inputs.filter((_, i) => i !== index));
  };

  const handleChange1 = (index, event) => {
    const newInputs = [...inputs];
    newInputs[index][event.target.name] = event.target.value;
    setInputs(newInputs);
  };

  const handleCheckboxChange = (e) => {
    setIsCheckboxChecked(e.target.checked);
  };

  const [domesticSOW, setDomesticSOW] = useState({
    relocation_id: Relocation_ID,
    fit_to_fly_requirement: "",
    remark: "",
    discount: "",
    pet_boarding: "",
    vehicle_type: "",
  });

  const [firstItem, setFirstItem] = useState({
    relocationdetail_id: "",
    service_type: "",
    origin_city: "",
    destination_city: "",
    mode_of_transport: "",
    relocation_id: "",
    relocation_detail: "",
    origin_city1: "",
    destination_city1: "",
    delivery_type: "",
    delivery_type_name: "",
    ServiceTypeName: "",
    petbreedtype: "",
    pettype: "",
    number_of_pets: "",
    job_type: "",
    name: "",
  });


  function QuotationBuilderPage(relocation_id) {
    navigate("/QuotationBuilder", { state: { relocation_id: relocation_id } });
  }

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };


  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      setDecryptionError(true);

      return null;
    }
  }

  const goToLeadList = () => {
    // Redirect to another page
    navigate("/LeadList");
  };


  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setDomesticSOW((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
      [name]: name === 'fit_to_fly_requirement' ? (value === 'true') : value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!isCheckboxChecked) {
      alert("Please confirm the declaration before proceeding.");
      return;
    }

    const storedToken = JSON.parse(localStorage.getItem("token"));

    try {

      const response1 = await axios.post(
        `${baseAPI}userpost/AddUpdateDomesticSOW`,
        domesticSOW,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      const response = await axios.post(
        `${baseAPI}userpost/AddUpdateAdditionalSOW`,
        inputs,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      setIsEditMode(!isEditMode);

    } catch (error) {
      console.error('Error saving data:', error);

    }
  };


  useEffect(() => {

    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}userget/GetSOWRelocationDetail?relocation_id=` + Relocation_ID, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setFirstItem(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });


      axios
        .get(`${baseAPI}userget/GetSOWDomestic?relocation_id=` + Relocation_ID, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response1) => {
          setDomesticSOW(response1.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}userget/GetAdditionalSOW?relocation_id=` + Relocation_ID, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setInputs(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching additional SOW detail:", error);
        });
    }
  }, []);


  return (
    <div>
      <div className="app-container-viewLeadDetails">
        <MiniDrawer />
        <div className="container-fluid container-viewLeadDetails">
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                <a style={{ cursor: "pointer" }} onClick={goToLeadList}>
                  Scope of Work{" "}
                </a>{" "}
                | <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; Lead Details</span>
                <span style={{ fontSize: "20px" }}>&gt; View Lead Details</span>
                <span style={{ fontSize: "20px" }}>&gt; Scope of Work</span>
              </h1>
            </div>
            <div className="div_leadID"   >
              Lead ID: 123456
            </div>
          </div>
          <Wrapper className="LeadDetails2">
            {/* ----------------------------------Step1 & Step 2-------------------------------- */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "2px",
                backgroundColor: "white",
                paddingBottom: "5px",
                borderRadius: "10px 10px 10px 10px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    paddingTop: "1rem",
                    paddingLeft: "1rem",
                  }}
                >
                  Step 1 | Step 2
                </span>
                <div style={{ borderBottom: "2px solid blue," }}></div>
              </div>
              {/* ----------------------------------Quotation builder-------------------------------- */}
              <div>
                <button
                  onClick={() =>
                    QuotationBuilderPage(firstItem.relocation_id)
                  }
                  className="btn btn-primary"
                  style={{
                    margin: "5px 4px 5px 0px",
                    backgroundColor: "white",
                    color: "#6A6A6A",
                    borderColor: "#C0C6CC",
                    height: "53px",
                    width: "210px",
                  }}
                >
                  <img
                    src={quoation}
                    alt="Quotation Builder"
                    style={{
                      marginRight: "8px",
                      width: "10px",
                      height: "13px",
                      marginBottom: "3px",
                    }}
                  />
                  QUOTATION BUILDER
                </button>

                <button
                  className={
                    isEditMode
                      ? "btn btn-primary edit-Button-on"
                      : "btn btn-primary edit-Button-off"
                  }
                  onClick={toggleEditMode}
                  style={{
                    margin: "5px 4px 5px 0px",
                    backgroundColor: "white",
                    color: "#6A6A6A",
                    borderColor: "#C0C6CC",
                    height: "55px",
                    width: "84px",
                  }}
                >
                  <img
                    src={pencil}
                    alt="Quotation Builder"
                    style={{
                      marginRight: "8px",
                      width: "12px",
                      height: "13px",
                      marginBottom: "3px",
                    }}
                  />
                  EDIT
                </button>

                <button
                  className="btn btn-primary"
                  style={{
                    margin: "5px 4px 5px 0px", //
                    backgroundColor: "white",
                    color: "#6A6A6A",
                    borderColor: "#C0C6CC",
                    height: "55px",
                    width: "128px", //
                  }}
                >
                  <img
                    src={edit}
                    alt="Quotation Builder"
                    style={{
                      marginRight: "8px",
                      width: "18px",
                      height: "18px",
                      marginBottom: "3px",
                    }}
                  />
                  LEAD LIST
                </button>
              </div>
            </div>
          </Wrapper>
          <br />
          {/* ------------------------lead deatil--------------------- */}

          <Wrapper className="LeadDetails">
            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",

                  borderRadius: "12px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={4}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}> Details </span>
                  </th>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Relocation ID</span>
                  </th>
                  <td>
                    <span>{firstItem.relocation_id}</span>
                  </td>
                  <th>
                    <span>Name</span>
                  </th>
                  <td>
                    <span>{firstItem.name}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Service Type</span>
                  </th>
                  <td>
                    <span>{firstItem.ServiceTypeName}</span>
                  </td>
                  <th>
                    <span>Delivery Type</span>
                  </th>
                  <td>
                    <span>{firstItem.delivery_type_name}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>From City</span>
                  </th>
                  <td>
                    <span>{firstItem.origin_city1}</span>
                  </td>
                  <th>
                    <span>To City</span>
                  </th>
                  <td>
                    <span>{firstItem.destination_city1}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Mode of Transportation</span>
                  </th>
                  <td>
                    <span>Road</span>
                  </td>
                  <th>
                    <span>Number of Pets</span>
                  </th>
                  <td>
                    <span>{firstItem.number_of_pets}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Pet Type</span>
                  </th>
                  <td>
                    <span>{firstItem.pettype}</span>
                  </td>
                  <th>
                    <span>Pet Breed</span>
                  </th>
                  <td>
                    <span>{firstItem.petbreedtype}</span>
                  </td>

                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Job Type</span>
                  </th>
                  <td colSpan={3}>
                    <span>{firstItem.job_type}</span>
                  </td>
                </tr>



              </table>
            </div>
            {successMessage && (
              <div style={{ color: "green" }}>{successMessage}</div>
            )}
            {isEditMode ? (
              <>
                {/* ----------Edit mode--------------- */}

                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                  }}
                >
                  <tr style={{ paddingTop: "0.5rem" }}>
                    <th>
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",
                          paddingTop: "0.5rem",
                          paddingLeft: "5px",
                        }}
                      >
                        {" "}
                        1. Do you Reqiure fit-to-Travel Certificate ?{" "}
                      </span>
                    </th>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td
                      style={{
                        paddingRight: "0.5rem",
                        color: "#A0A0A0",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <span style={{ paddingTop: "5px", paddingLeft: "28px" }}>
                        {" "}
                        A fit-to-fly Certificate(NOC) is required from a
                        certified Vet 24 hours before your flight. Cary My Pet
                        Assists you in gathering an NOC{" "}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        paddingTop: "5px",
                        paddingTop: "0.5rem",
                        paddingLeft: "5px",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="true"
                        checked={
                          domesticSOW.fit_to_fly_requirement === true
                        }
                        onChange={handleChange2}
                      />

                      <label
                        style={{
                          paddingLeft: "1rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        Fit-to-fly Certificate(Assisted)
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem" }}>
                      <label style={{ paddingLeft: "2rem", color: "#A0A0A0" }}>
                        {" "}
                        We are Partnered with certified internation labs at
                        pocket-friendly rates
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td
                      style={{
                        paddingTop: "0.5rem",
                        paddingLeft: "5px",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value="false"
                        checked={
                          domesticSOW.fit_to_fly_requirement === false
                        }
                        onChange={handleChange2}
                      />

                      <label
                        style={{
                          paddingLeft: "1rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        No Thanks, I will get one myself
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem" }}>
                      <label
                        style={{
                          paddingLeft: "2rem",
                          color: "#A0A0A0",

                        }}
                      >
                        {" "}
                        A fit-to-fly Certificate(NOC) is mandatory for a pet's
                        international travel.
                      </label>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem" }}>
                      <table style={{ width: "100%" }}>
                        <tr>
                          <td>
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                                paddingTop: "0.5rem",
                                paddingLeft: "5px",
                                fontWeight: "bold"
                              }}
                            > Choose Vehicle type:</span>
                            <select
                              className="form-control"
                              name="vehicle_type"
                              value={domesticSOW.vehicle_type}
                              onChange={handleChange2}
                            >
                              <option value="0">Not required</option>
                              <option value="1">mini</option>
                              <option value="2">XL</option>
                            </select>
                          </td>
                          <td>
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                                paddingTop: "0.5rem",
                                paddingLeft: "5px",
                                fontWeight: "bold"
                              }}
                            > Pet Boarding:</span>
                            <select
                              className="form-control"
                              name="pet_boarding"
                              value={domesticSOW.pet_boarding}
                              onChange={handleChange2}
                            >
                              <option value="0">Not required</option>
                              <option value="1">1 day</option>
                              <option value="2">2 day</option>
                              <option value="3">3 day</option>
                              <option value="4">4 day</option>
                              <option value="5">5 day</option>
                            </select>
                          </td>
                          <td>
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                                paddingTop: "0.5rem",
                                paddingLeft: "5px",
                                fontWeight: "bold"
                              }}
                            > Discount (if Any):</span>
                            <input
                              className="form-control"
                              type="text"
                              name="discount"
                              value={domesticSOW.discount}
                              placeholder="Please Enter*"
                              onChange={handleChange2}
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <th
                      style={{
                        fontSize: "18px",
                        color: "#6A6A6A",
                        paddingTop: "1rem",
                        paddingLeft: "0.5rem",
                        paddingBottom: "0.2rem",
                      }}
                    >
                      Any Remark
                    </th>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ paddingLeft: "0.5rem", paddingBottom: "1rem" }}
                    >
                      <input
                        className="form-control"
                        style={{
                          borderRadius: "1px solid #6A6A6A",
                          width: "98%",
                        }}
                        type="input"
                        name="remark"
                        value={domesticSOW.remark}
                        onChange={handleChange2}
                      />
                    </td>
                  </tr>
                </table>

                <div>
                  {inputs.map((input, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        background: 'rgb(248, 249, 250)',
                        paddingLeft: '0.5rem',
                        marginTop: '15px',
                        marginBottom: '10px',
                        height: '160px',
                        position: 'relative', // to use for positioning the X button
                      }}
                    >
                      <span
                        onClick={() => handleRemoveFields(index)}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '10px',
                          color: 'red',
                          cursor: 'pointer',
                          fontWeight: 'bold',
                        }}
                      >
                        X
                      </span>
                      <span
                        style={{
                          marginBottom: '0.5rem',
                          fontSize: '18px',
                          color: '#6A6A6A',
                          fontWeight: '700',
                        }}
                      >
                        Any Pet-Specific or Service Requirements We Should Know About?
                      </span>
                      <input
                        name="specific_requirement"
                        style={{
                          marginBottom: '1rem',
                          width: '98%',
                          height: '4rem',
                        }}
                        value={input.specific_requirement}
                        onChange={(event) => handleChange1(index, event)}
                      />
                      <span
                        style={{
                          marginBottom: '0.5rem',
                          fontSize: '18px',
                          color: '#6A6A6A',
                          fontWeight: '700',
                        }}
                      >
                        Price
                      </span>
                      <input className="form-control"
                        name="price"
                        style={{
                          marginBottom: '1rem',
                          width: '15%',
                          height: '4rem',
                        }}
                        value={input.price}
                        onChange={(event) => handleChange1(index, event)}
                      />
                    </div>
                  ))}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <button
                      onClick={handleAddFields}
                      style={{
                        position: 'relative',
                        padding: '0px',
                        backgroundColor: 'transparent',
                        border: 'none',
                      }}
                    >
                      <img
                        src={rectangle}
                        alt="Add"
                        style={{ width: '100%', height: 'auto' }}
                      />
                      <div
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                        }}
                      >
                        <img
                          src={add}
                          alt="Overlay"
                          style={{ width: '80%', height: 'auto' }}
                        />
                      </div>
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <table
                  style={{
                    background: "rgb(248, 249, 250)",
                    width: "100%",
                    borderRadius: "12px",
                  }}
                >
                  <tr style={{ paddingTop: "0.2rem" }}>
                    <th>
                      <span
                        style={{
                          fontSize: "18px",
                          wordSpacing: "0.1rem",
                          color: "#6A6A6A",

                          paddingLeft: "0.5rem",
                          paddingTop: "1rem",
                        }}
                      >
                        {" "}
                        1. Do you Require fit-to-Travel Certificate ?{" "}
                      </span>
                    </th>
                  </tr>
                  <tr className="viewLeadDetailsHeadingradio">
                    <td
                      style={{
                        paddingRight: "0.5rem",
                        color: "#A0A0A0",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <label style={{ paddingTop: "5px", paddingLeft: "28px" }}>
                        {" "}
                        A fit-to-fly Certificate(NOC) is required from a
                        certified Vet 24 hours before your flight. Cary My Pet
                        Assists you in gathering an NOC{" "}
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value='true'
                        checked={
                          domesticSOW.fit_to_fly_requirement === true
                        }
                        disabled
                      />
                      <label
                        style={{
                          paddingLeft: "1rem",
                          color: "#6A6A6A",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        Fit-to-fly Certificate(Assisted)
                      </label>
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                      <label
                        style={{ paddingLeft: "1.7rem", color: "#A0A0A0" }}
                      >
                        {" "}
                        We are Partnered with certified international labs at
                        pocket-friendly rates
                      </label>
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeadingradio">
                    <td
                      style={{

                        paddingTop: "0.5rem",
                        paddingLeft: "0.5rem",
                      }}
                    >
                      <input
                        type="radio"
                        name="fit_to_fly_requirement"
                        value='false'
                        checked={
                          domesticSOW.fit_to_fly_requirement === false
                        }
                        disabled
                      />
                      <label
                        style={{

                          color: "#6A6A6A",
                          fontWeight: "600",
                          paddingLeft: "0.5rem",
                        }}
                      >
                        {" "}
                        No Thanks, I will get one myself
                      </label>
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem" }}>
                      <label
                        style={{ paddingLeft: "1.7rem", color: "#A0A0A0" }}
                      >
                        {" "}
                        A fit-to-fly Certificate(NOC) is mandatory for a pet's
                        international travel.
                      </label>
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeadingradio">
                    <td style={{ paddingTop: "0.5rem" }}>
                      <table style={{ width: "100%" }}>
                        <tr>
                          <td>
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                                paddingTop: "0.5rem",
                                paddingLeft: "5px",
                                fontWeight: "bold"
                              }}
                            > Choose Vehicle type:</span>
                            <select
                              className="form-control"
                              name="vehicle_type"
                              value={domesticSOW.vehicle_type}
                              disabled
                            >
                              <option value="0">Not required</option>
                              <option value="1">4 seater</option>
                              <option value="2">7 seater</option>
                            </select>
                          </td>
                          <td>
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                                paddingTop: "0.5rem",
                                paddingLeft: "5px",
                                fontWeight: "bold"
                              }}
                            > Pet Boarding:</span>
                            <select
                              className="form-control"
                              name="pet_boarding"
                              value={domesticSOW.pet_boarding}
                              disabled
                            >
                              <option value="0">Not required</option>
                              <option value="1">1 day</option>
                              <option value="2">2 day</option>
                              <option value="3">3 day</option>
                              <option value="4">4 day</option>
                              <option value="5">5 day</option>
                            </select>
                          </td>
                          <td>
                            <span
                              style={{
                                fontSize: "18px",
                                wordSpacing: "0.1rem",
                                color: "#6A6A6A",
                                paddingTop: "0.5rem",
                                paddingLeft: "5px",
                                fontWeight: "bold"
                              }}
                            > Discount (if Any):</span>
                            <input
                              className="form-control"
                              type="text"
                              name="discount"
                              value={domesticSOW.discount}
                              placeholder="Please Enter*"
                              disabled
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>




                  <tr>
                    <th
                      style={{
                        fontSize: "18px",
                        color: "#6A6A6A",
                        paddingTop: "1rem",
                        paddingLeft: "0.5rem",
                        paddingBottom: "0.2rem",
                      }}
                    >
                      Any Remark
                    </th>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ paddingLeft: "0.5rem", paddingBottom: "1rem" }}
                    >
                      <input
                        style={{
                          borderRadius: "1px solid #6A6A6A",
                          width: "98%",
                        }}
                        type="input"
                        name="remark"
                        value={domesticSOW.remark}
                        disabled
                      />
                    </td>
                  </tr>
                </table>
                <div>
                  {inputs.map((input, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        background: 'rgb(248, 249, 250)',
                        paddingLeft: '0.5rem',
                        marginTop: '15px',
                        marginBottom: '10px',
                        height: '160px',
                      }}
                    >
                      <span
                        style={{
                          marginBottom: '0.5rem',
                          fontSize: '18px',
                          color: '#6A6A6A',
                          fontWeight: '700',
                        }}
                      >
                        Any Pet-Specific or Service Requirements We Should Know About?
                      </span>
                      <input
                        name="specific_requirement"
                        style={{
                          marginBottom: '1rem',
                          width: '98%',
                          height: '4rem',
                        }}
                        value={input.specific_requirement}
                        onChange={(event) => handleChange1(index, event)}
                        disabled
                      />
                      <span
                        style={{
                          marginBottom: '0.5rem',
                          fontSize: '18px',
                          color: '#6A6A6A',
                          fontWeight: '700',
                        }}
                      >
                        Price
                      </span>
                      <input
                        name="price"
                        style={{
                          marginBottom: '1rem',
                          width: '15%',
                          height: '4rem',
                        }}
                        value={input.price}
                        onChange={(event) => handleChange1(index, event)}
                        disabled
                      />
                    </div>
                  ))}
                </div>
              </>
            )}
          </Wrapper>

          <Wrapper style={{ marginTop: "1rem" }}>
            <div
              style={{
                backgroundColor: "white",
                paddingTop: "2rem",
                paddingLeft: "2rem",
                marginTop: "35px",
                paddingBottom: "2rem",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#6A6A6A",
                }}
              >
                Requirement to obtain an Export Permit:
              </p>
              <div
                style={{
                  fontWeight: "400",
                  fontSize: "15px",
                  color: "#6A6A6A",
                  paddingBottom: "2rem",
                }}
              >
                <p>1. Latest Vaccination record.</p>
                <p>2. Pick-up details and drop details.</p>

                <p>
                  3. Provide a signed booking form & Carry My Pet declaration.{" "}
                  <span style={{ fontWeight: "bold" }}>
                    (We'll share the format)
                  </span>
                </p>

                <div>
                  <div style={{ paddingTop: "2rem" }}>
                    <input
                      type="checkbox"
                      checked={isCheckboxChecked}
                      onChange={handleCheckboxChange}
                    />
                    <label style={{ paddingLeft: "1rem" }}>
                      I declare that I've confirmed the complete list of
                      documentation and I will be sharing this with the customer
                      shortly
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-start",
            }}
          >
            <button
              style={{
                alignSelf: "flex-start",
                marginRight: "2rem",
                padding: 0,
                border: "none",
                background: "none",
              }}

              onClick={handleSave}
            >
              <img
                src={updatebutton}
                alt="update"
                style={{ width: "200px", height: "50px", marginTop: "1rem" }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>


  );
};

export default DomesticRelocationRoad;
